import { AxiosRequestConfig } from 'axios'
import { ApiResponse } from '../models/api-response'
import { callExternalApi } from './external-api.service'

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL
const awsUrl = `${apiServerUrl}`

export const getPublicResource = async (): Promise<ApiResponse> => {
  const config: AxiosRequestConfig = {
    url: `${apiServerUrl}/api/messages/public`,
    method: 'GET',
    headers: {
      'content-type': 'application/json',
    },
  }
  const { data, error } = (await callExternalApi({ config })) as ApiResponse
  return { data, error }
}

export const getProtectedResource = async (): Promise<ApiResponse> => {
  const config: AxiosRequestConfig = {
    url: `${apiServerUrl}/api/messages/protected`,
    method: 'GET',
    headers: {
      'content-type': 'application/json',
    },
  }

  const { data, error } = (await callExternalApi({ config })) as ApiResponse

  return {
    data,
    error,
  }
}

export const getAdminResource = async (): Promise<ApiResponse> => {
  const config: AxiosRequestConfig = {
    url: `${apiServerUrl}/api/messages/admin`,
    method: 'GET',
    headers: {
      'content-type': 'application/json',
    },
  }

  const { data, error } = (await callExternalApi({ config })) as ApiResponse

  return {
    data,
    error,
  }
}

// MEASUEREMENT

export const getMeasurementResourceAuth = async (accessToken: string): Promise<ApiResponse> => {
  const config: AxiosRequestConfig = {
    url: `${awsUrl}/measurement?name=см3`,
    method: 'GET',
    withCredentials: true,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  }
  const { data, error } = (await callExternalApi({ config })) as ApiResponse
  return { data, error }
}

export const getMeasurementResource = async (): Promise<ApiResponse> => {
  const url = `${awsUrl}/measurement?name=см3`
  console.log('awsUrl = ', url)

  const config: AxiosRequestConfig = {
    url,
    method: 'GET',
    // withCredentials: false,
    headers: {
      'content-type': 'application/json',
    },
  }
  const { data, error } = (await callExternalApi({ config })) as ApiResponse
  return { data, error }
}

// PRODUCT

export const getProductResourceAuth = async (accessToken: string): Promise<ApiResponse> => {
  const url = `${awsUrl}/product`

  const config: AxiosRequestConfig = {
    url,
    method: 'GET',
    // withCredentials: true,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  }
  const { data, error } = (await callExternalApi({ config })) as ApiResponse
  return { data, error }
}

export const getProductResourceAuth___ = async (accessToken: string): Promise<ApiResponse> => {
  const config: AxiosRequestConfig = {
    url: `${awsUrl}/product`,
    method: 'GET',
    withCredentials: true,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  }
  const { data, error } = (await callExternalApi({ config })) as ApiResponse
  return { data, error }
}
